import React from 'react';
import authenticate from '../services/authentication';
import './Login.css';

class Login extends React.Component {
  constructor(props) {    
    super(props);
    this.handleChange = this.handleChange.bind(this);
    this.handleLogin = this.handleLogin.bind(this);    
    this.state = {username: '',password:''};    
  }
  handleChange(e) {    
    var state = {};
    state[e.target.name] = e.target.value
    this.setState(state);    
  }
  handleLogin(e){        
    var key = authenticate(this.state.username,this.state.password);    
    this.props.handleLogin(key);      
    e.preventDefault();
  }  
  render() {
    const username = this.state.username;
    const password = this.state.password;
    return (
      <div className="login-background">
        <div className="login-page">
          <div className="form">        
            <form className="login-form" onSubmit={this.handleLogin}>
              <input type="text" value={username} onChange={this.handleChange} name="username" placeholder="Usuário'"/>
              <input type="password" value={password} onChange={this.handleChange} name="password" placeholder="Senha"/>
              <button>Entrar</button>          
            </form>
          </div>
        </div>   
      </div>   
    )
    ;
  }
}

export default Login;


// WEBPACK FOOTER //
// ./src/pages/Login.js